  // import React, { useState } from 'react';
// import { Button, NewTable } from '../../../../components';
// import { allBillsrowdata } from '../../../../assets/data/candidatesData';
// import { mapTableRows } from '../../../../utils';
// import WaitingforApprovalinvoiceDetails from './WaitingforApproval/WaitingforApprovalinvoiceDetails';

// const WaitingforApproval = () => {
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [selectedInvoice, setSelectedInvoice] = useState(null);
//   const [view, setView] = useState("list"); // "list" | "details"

//   const tablerowData = allBillsrowdata;

//   const handleSelectRow = (rowId) => {
//     setSelectedRows((prevSelected) =>
//       prevSelected.includes(rowId)
//         ? prevSelected.filter((id) => id !== rowId)
//         : [...prevSelected, rowId]
//     );
//   };

//   const handleInvoiceNumberClick = (row) => {
//     setSelectedInvoice(row);
//     setView("details");
//   };

//   const handleBack = () => {
//     setSelectedInvoice(null);
//     setView("list");
//   };

//   const WaitingforapprovalColumns = [
//      {
//       key: "InvoiceNumber",
//       label: "Invoice Number",
//       render: (row) => (
//         <span
//           className="cursor-pointer text-linkblue"
//           onClick={() => handleInvoiceNumberClick(row)}
//         >{row.InvoiceNumber}
//         </span>
//       ),
//     },
//     { key: "Employees", label: "Employees" },
//     { key: "VendorID", label: "Vendor ID" },
//     { key: "InvoiceDate", label: "Invoice Date" },
//     { key: "InvoiceDueDate", label: "Invoice Due Date" },
//     { key: "BillAmount", label: "Bill Amount" },
//     { key: "PaidAmount", label: "Paid Amount" },
//     { key: "DiscountAmount", label: "Discount Amount" },
//     { key: "DueAmount", label: "Due Amount" },
//     { key: "Createdon", label: "Created On" },
//     {
//       key: "actions",
//       label: "Actions",
//       render: (row) => (
//         <div className="flex items-center gap-2">
//           <Button
//             type="icon"
//             icon="download"
//             size="xs"
//             variant="text"
//             color="black"
//             onClick={""}
//           />
//           <Button
//             type="icon"
//             icon="edit_square"
//             size="xs"
//             variant="text"
//             color="black"
//             onClick={""}
//           />
//           <Button
//             type="icon"
//             icon="delete"
//             size="xs"
//             variant="text"
//             color="black"
//             onClick={""}

//           />
//         </div>
//       ),
//     },
//   ];

//   const mappedRows = mapTableRows(tablerowData, WaitingforapprovalColumns);

//   return (
//     <div>
//       {view === "list" && (
//         <NewTable
//           showCheckbox
//           columns={WaitingforapprovalColumns}
//           rows={mappedRows}
//           toolbarRight={[
//             { filterButton: false },
//             { DropdownMenu: false },
//           ]}
//         />
//       )}
//       {view === "details" && selectedInvoice && (
//         <WaitingforApprovalinvoiceDetails data={selectedInvoice} onBack={handleBack} />
//       )}
//     </div>
//   );
// };

// export default WaitingforApproval;

import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  LogoLoader,
  NewTable,
  StatusTags,
} from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import { getVendorId } from "../../../../utils/getClientId";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../hooks";
import { getAccountPayablesStart } from "../../../../redux/slices/accountPayables/accountPayablesSlice";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import WaitingforApprovalinvoiceDetails from "./WaitingforApproval/WaitingforApprovalinvoiceDetails";
import { useNavigate } from "react-router-dom";
import { formatCurrency } from "../../../../utils/stringUtils";

const WaitingforApproval = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [view, setView] = useState("list");
  const [sortConfig, setSortConfig] = useState({
    field: "uiid",
    direction: -1,
  });

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    }
  );

  const { accountPayables, loading } = useSelector(
    (state) => state.accountPayables
  );
  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.accountpayables?.data;

  const handleSort = (field) => {
    setSortConfig((prevSort) => ({
      field,
      direction: prevSort.field === field ? -prevSort.direction : -1,
    }));
  };

  const handleInvoiceNumberClick = (row) => {
    setSelectedInvoice(row);
    setView("details");
  };

  const handleBack = () => {
    setSelectedInvoice(null);
    setView("list");
  };

  const columns = [
    {
      key: "invoiceNum",
      label: "Invoice Number",
      render: (row) => (
        <span
          className="cursor-pointer text-linkblue"
          onClick={() => handleInvoiceNumberClick(row)}
        >
          {row.invoiceNum}
        </span>
      ),
    },
    {
      key: "employeeId",
      label: "Employees",
      render: (row) => (
        <div>
          {row.employeeId.map((item, index) => (
            <span key={index}>
              {[item.firstName, item.lastName].filter(Boolean).join(" ")}
              {index < row.employeeId.length - 1 && ", "}
            </span>
          ))}
        </div>
      ),
    },
    {
      key: "vendorId",
      label: "Vendor",
      render: (row) => <div>{row.vendorId.businessName || '-'}</div>,
    },
    {
      key: "VendorID",
      label: "Vendor ID",
      render: (row) => <div>{getVendorId(row.vendorId.uiid)}</div>,
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
      render: (row) => dateFormator(row.invoiceDate, "month-day-year"),
    },
    {
      key: "dueDate",
      label: "Invoice Due Date",
      render: (row) => dateFormator(row.dueDate, "month-day-year"),
    },
    {
      key: "billedAmount",
      label: "Bill Amount",
      render: (row) => formatCurrency(row.amounts.billed),
    },
    {
      key: "paidAmount",
      label: "Paid Amount",
      render: (row) => formatCurrency(row.amounts.paid),
    },
    {
      key: "discountAmount",
      label: "Discount Amount",
      render: (row) => formatCurrency(row.amounts.discount),
    },
    {
      key: "dueAmount",
      label: "Due Amount",
      render: (row) => formatCurrency(row.amounts.due),
    },
    {
      key: "addedOn",
      label: "Created On",
      render: (row) => dateFormator(row.addedOn, "month-day-year"),
    },
    {
      key: "modifiedOn",
      label: "Modified On",
      render: (row) => dateFormator(row.modifiedOn, "month-day-year"),
    },
    {
      key: "isModify",
      label: "Is Modified",
      render: (row) => <StatusTags tag={row.isModify ? "Yes" : "No"} />,
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2">
          <Button
            type="icon"
            icon="download"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
          <Button
            type="icon"
            icon="edit_square"
            size="xs"
            variant="text"
            color="black"
            // onClick={()=>navigate(`/accounts-payable/edit/${row.uiid}`)}
            onClick={() => handleInvoiceNumberClick(row)}
          />
          <Button
            type="icon"
            icon="delete"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
        </div>
      ),
    },
  ];

  const mappedRows = mapTableRows(accountPayables?.data || [], columns);

  useEffect(() => {
    if (view === "list") {
      dispatch(
        getAccountPayablesStart({
          limit,
          page,
          filters: {
            status: {
              type: "NONE",
              value: 2,
            },
          },
          ref: "Employee Vendor Document",
          incl: ["firstName lastName", "businessName", ""],
          sort: { [sortConfig.field]: sortConfig.direction },
        })
      );
      dispatch(
        totalCountStart({
          filters: {
            status: {
              type: "NONE",
              value: 2,
            },
          },
          collection: "accountpayables",
          coll: "AccountPayable",
        })
      );
    }
  }, [dispatch, view, page, limit, sortConfig]);

  return (
    <div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      {view === "list" && (
        <NewTable
          showCheckbox
          columns={columns}
          rows={mappedRows}
          toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
          serverPagination
          totalCount={totalCount}
          page={page}
          limit={limit}
          onPageChange={setPage}
          onLimitChange={handleLimitChange}
        />
      )}
      {console.log("selectedInvoice", selectedInvoice)}
      {view === "details" && selectedInvoice && (
        <WaitingforApprovalinvoiceDetails
          data={selectedInvoice}
          onBack={handleBack}
        />
      )}
    </div>
  );
};

export default WaitingforApproval;
